module.exports = {
	"edit.topic": "Edit Topic",
    "topic.title": "Title",
    "tip.input.title": "title required",
    "confirm.remove.topic": "do remove topic",
    "confirm.remove.comment": "do remove comment",
    "reply.topic": "Comment",
    "edit.comment": "Edit Comment",
    "reply.to": "Comment to",
	"my.comment": "My Comment",
	"post.comment": "Post",
	"relevant.topic": "Relevant Topic",
	"share.to": "Share With",
    "share.wx": "Share with webchat",
    "share.wx.action": "open webchat, click 'discovery', share the webpage with scaning the qrcode",
    "content.length": "the length of content is too short",
    "tag": "Tags",
    "topic.tag": "Tag, press enter to add",
    "tag.length": "The length of characters must be less than {{max}}",
    "tag.count": "The count of tags must be less than {{max}}",
    "comment.list": "Comment List",
    "copy.success": "Copy successfully",
    "make.answer": "mark it as answer",
    "top.answer": "Best answer",
    "confirm.answer": "Make it as answer?",
    "answered": "Resovled",
    "official": "Recommend"
}


// WEBPACK FOOTER //
// ./src/pages/topic/i18n/locale.en.js